import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useVendasStore } from '../store/VendasStore';

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString('pt-BR', {
    month: 'short',
  });

  const daysInMonth = date.getDate();

  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

export default function SessionsChart() {
  const { toal_vendido, todas_as_vendas_pix, todas_as_vendas_debito, todas_as_vendas_credito, mes_atual, ano, mostrar_grafico_valores_das_vendas } = useVendasStore();

  const theme = useTheme();


  if (mostrar_grafico_valores_das_vendas && toal_vendido > 0) {
    const data = getDaysInMonth(mes_atual, ano);

    const colorPalette = ['#4E79A7', '#F28E2B', '#59A14F'];

    const pix = todas_as_vendas_pix
    const debito = todas_as_vendas_debito
    const credito = todas_as_vendas_credito

    return (
      <Card variant="outlined" sx={{ width: '100%' }}>
        <CardContent>
          <Stack sx={{ justifyContent: 'space-between' }}>
            <Stack
              direction="row"
              sx={{
                alignContent: { xs: 'center', sm: 'flex-start' },
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Typography variant="h4" component="p">
                {toal_vendido.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }) ?? '0'}
              </Typography>
            </Stack>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              * Dados referentes ao mês corrente.
            </Typography>
          </Stack>

          <BarChart
            colors={colorPalette}
            xAxis={[{ scaleType: 'band', data }]}
            yAxis={[{
              width: 50,
              tickNumber: 5, // força 10 divisões no eixo Y: [0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000],
            }]}
            series={[
              {
                data: pix,
                label: 'PIX',
                valueFormatter: (value) =>
                  value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
              },
              {
                data: debito,
                label: 'DÉBITO',
                valueFormatter: (value) =>
                  value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
              },
              {
                data: credito,
                label: 'CRÉDITO',
                valueFormatter: (value) =>
                  value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
              },
            ]}
            height={300}
            margin={{ left: 0, right: 20, top: 20, bottom: 40 }}
            grid={{ horizontal: true }}
          />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      variant="outlined"
      sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
    >
      <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
        * Para ver o gráfico das vendas do mês faça uma venda.
      </Typography>
    </Card>
  );
}


// import * as React from 'react';
// import PropTypes from 'prop-types';
// import { useTheme } from '@mui/material/styles';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Chip from '@mui/material/Chip';
// import Typography from '@mui/material/Typography';
// import Stack from '@mui/material/Stack';
// import { LineChart } from '@mui/x-charts/LineChart';
// import { useVendasStore } from '../store/VendasStore';

// function AreaGradient({ color, id }) {
//   return (
//     <defs>
//       <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
//         <stop offset="0%" stopColor={color} stopOpacity={0.5} />
//         <stop offset="100%" stopColor={color} stopOpacity={0} />
//       </linearGradient>
//     </defs>
//   );
// }

// AreaGradient.propTypes = {
//   color: PropTypes.string.isRequired,
//   id: PropTypes.string.isRequired,
// };




// function getDaysInMonth(month, year) {
//   const date = new Date(year, month, 0);
//   const monthName = date.toLocaleDateString('pt-BR', {
//     month: 'short',
//   });

//   const daysInMonth = date.getDate();

//   const days = [];
//   let i = 1;
//   while (days.length < daysInMonth) {
//     console.log(`${monthName} ${i}`)
//     days.push(`${monthName} ${i}`);
//     i += 1;
//   }
//   return days;
// }

// export default function SessionsChart() {

//   const { toal_vendido, todas_as_vendas_pix, todas_as_vendas_debito, todas_as_vendas_credito, mes_atual, ano } = useVendasStore()

//   const theme = useTheme();
//   const data = getDaysInMonth(mes_atual, ano);

//   const colorPalette = [
//     '#4E79A7',
//     '#F28E2B',
//     '#59A14F',
//   ];

//   return (
//     <Card variant="outlined" sx={{ width: '100%' }}>
//       <CardContent>
//         <Stack sx={{ justifyContent: 'space-between' }}>
//           <Stack
//             direction="row"
//             sx={{
//               alignContent: { xs: 'center', sm: 'flex-start' },
//               alignItems: 'center',
//               gap: 1,
//             }}
//           >
//             <Typography variant="h4" component="p">
//               {toal_vendido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) ?? '0'}
//             </Typography>
//           </Stack>
//           <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//             * Dados refentes ao mês corrente.
//           </Typography>
//         </Stack>
//         <LineChart
//           colors={colorPalette}
//           xAxis={[
//             {
//               scaleType: 'point',
//               data,
//               tickInterval: (index, i) => (i + 1) % 5 === 0,
//               height: 24,
//             },
//           ]}
//           yAxis={[{ width: 50 }]}
//           series={[
//             {
//               type:'line',
//               id: 'PIX',
//               label: 'PIX',
//               showMark: false,
//               curve: 'catmullRom',
//               stack: 'total',
//               area: true,
//               stackOrder: 'ascending',
//               data: todas_as_vendas_pix,
//               valueFormatter: (value) =>
//                 value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
//             },
//             {
//               id: 'DÉBITO',
//               label: 'DÉBITO',
//               showMark: false,
//               curve: 'catmullRom',
//               stack: 'total',
//               area: true,
//               stackOrder: 'ascending',
//               data: todas_as_vendas_debito,
//               valueFormatter: (value) =>
//                 value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
//             },
//             {
//               id: 'CRÉDITO',
//               label: 'CRÉDITO',
//               showMark: false,
//               curve: 'catmullRom',
//               stack: 'total',
//               area: true,
//               stackOrder: 'ascending',
//               data: todas_as_vendas_credito,
//               valueFormatter: (value) =>
//                 value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
//             },
//           ]}
//           height={250}
//           margin={{ left: 0, right: 20, top: 20, bottom: 0 }}
//           grid={{ horizontal: true }}
//           sx={{
//             '& .MuiAreaElement-series-organic': {
//               fill: "url('#PIX')",
//             },
//             '& .MuiAreaElement-series-referral': {
//               fill: "url('#DÉBITO')",
//             },
//             '& .MuiAreaElement-series-direct': {
//               fill: "url('#CÉBITO')",
//             },
//           }}
//         // hideLegend
//         >
//           <AreaGradient color={theme.palette.primary.dark} id="PIX" />
//           <AreaGradient color={theme.palette.primary.main} id="CRÉDITO" />
//           <AreaGradient color={theme.palette.primary.light} id="DÉBITO" />
//         </LineChart>
//       </CardContent>
//     </Card>
//   );
// }
